import { isEmptyObject } from "../../../utils/tests";
import { LmpPreviewArticleQuery } from '../types';

/**
 * typeguard for LmpPreviewArticleQuery
 * @param obj LmpPreviewArticleQuery object passed to transformer
 */

export const isValidLmpPreviewArticleQuery = (obj: LmpPreviewArticleQuery): boolean => Boolean(obj?.data?.getLmpPreviewText && !isEmptyObject(obj.data.getLmpPreviewText));

